import { render, staticRenderFns } from "./safeCourse.vue?vue&type=template&id=0daaa2fe&scoped=true"
import script from "./safeCourse.vue?vue&type=script&lang=js"
export * from "./safeCourse.vue?vue&type=script&lang=js"
import style0 from "./safeCourse.vue?vue&type=style&index=0&id=0daaa2fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daaa2fe",
  null
  
)

export default component.exports